const baseURL = import.meta.env.VITE_APP_BASE_URL || 'http://localhost:8080'
const payGatewayUrl = import.meta.env.VITE_PAY_GATEWAY_URL || ''

export default { baseURL, payGatewayUrl }
